import { useEffect, useState } from "react";

import type { AstNative } from "@omni/ads";

import { useTcfPermission } from "../../../tcf/helpers";
import { useModal } from "../../../hooks/useModal/useModal";
import { getPulseTracker } from "../../../pulse";
import { AdInfoModal } from "../../Ad/Adinfo/components/Container";
import { TemplateHandler } from "./templates";

const TeaserInjectableNative = ({
  ad,
  layout,
  isLoggedIn,
  creativeId,
}: {
  ad: AstNative;
  isLoggedIn: boolean;
  creativeId: string;
  layout: "small" | "large";
}) => {
  const [privacyUrl, setPrivacyUrl] = useState("");
  const { ModalWrapper, isOpen, ref, open, close } = useModal();
  const advertisingConsent = useTcfPermission("CMP:advertising");

  const modal = isOpen ? (
    <ModalWrapper>
      <AdInfoModal
        privacyUrl={privacyUrl}
        creativeId={creativeId}
        closeModal={close}
        modalRef={ref}
      />
    </ModalWrapper>
  ) : null;

  useEffect(() => {
    (async () => {
      if (isLoggedIn) {
        setPrivacyUrl("https://privacysettings.schibsted.com/");
      } else {
        const pulse = getPulseTracker();
        const pulseEnvId = await pulse?.pulseTracker.getEnvironmentId();
        const pulsePrivacyUrl = `https://privacysettings.schibsted.com/?environment_id=${pulseEnvId}`;
        setPrivacyUrl(pulsePrivacyUrl);
      }
    })();
  }, [isLoggedIn]);

  return (
    <TemplateHandler
      advertisingConsent={advertisingConsent}
      ad={ad}
      layout={layout}
      open={open}
      modal={modal}
    />
  );
};

export { TeaserInjectableNative };
